module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "history tab-panel padded"
  }, [(_vm.items.length > 0) ? _c('div', {
    staticClass: "m-3"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "d-flex align-items-center fs-small mb-3"
    }, [_c('div', {
      staticClass: "pr-4"
    }, [_c('img', {
      attrs: {
        "src": '/static/images/' + item.image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "flex-all"
    }, [_c('strong', [_vm._v(_vm._s(item.name))]), _vm._v(" " + _vm._s(item.event) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "dark ml-auto"
    }, [_vm._v("\n                " + _vm._s(item.when) + "\n            ")])])
  }), 0) : _c('p', {
    staticClass: "m-3"
  }, [_vm._v("You have no information available yet.")]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "options bg-lighter dark py-3 px-5 fs-small"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Settings")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-daee1678", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-daee1678"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/view/ViewHistory.vue
// module id = 1269
// module chunks = 0